module.exports = __webpack_public_path__ + "static/media/paragraph.75097405.svg";